import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

import { LANGUAGES, LanguageCode } from 'i18n/constants'

export default function LanguageSwitcher(): JSX.Element {
  const { i18n, t } = useTranslation()

  const handleLanguageChange = (event: SelectChangeEvent) => {
    i18n.changeLanguage(event.target.value as LanguageCode)
  }

  return (
    <div style={containerStyle}>
      <span style={labelStyle}>{t('language.switch')}</span>
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        size="small"
        sx={{ minWidth: 140 }}
      >
        {Object.entries(LANGUAGES).map(([code, label]) => (
          <MenuItem key={code} value={code}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}

// Styles
const containerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '16px',
}

const labelStyle: CSSProperties = {
  fontSize: '14px',
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
}
